<template>
  <div>
    <TasksNav @search_by_title="search_by_title"
              @filter="filter" :tasks_count="tasks_count"
              @clear="get_tasks();is_searched=false;is_filtered=false;"
              @create_task="add_task_dialog=true;get_task_manages_data()"
              @manage="manage_view" @ListDevices_show="ListDevices_show=true;"
              @get_report="get_report_dialog=true;get_task_manages_data();"
    />
    <v-alert v-if="is_filtered" color="white" class="text-center mx-5 mt-5">
      <h2 style="color: green;">
        فیلتر شده با
        {{filter_name_handler(filter_by.key)}}
        هایی که برابر
        <strong>
          "<i>{{filter_by.value}}</i>"
        </strong>
        هستند
      </h2>
    </v-alert>
    <TasksList @refresh_tasks="get_tasks();" :tasks="tasks" :is_searched="is_searched || is_filtered" @change_tab="change_tab" @change_page="change_page" :receiving_tasks="receiving_tasks" :page="page"/>
    <CreateTask v-if="add_task_dialog"
                :manage_data="manage_data" :users_l2="users.l2"
                :add_task_dialog="add_task_dialog" :devices="devices"
                :loading_data="loading_create_data"
                @force_update_data="force_update_create_data()"
                @close="add_task_dialog=false;"
                @refresh_tasks="get_tasks();"
    />
    <TaskManage @close="manage.show=false;" :show_manage="manage.show" :manage="manage"></TaskManage>
    <ListDevices @close="ListDevices_show=false;" v-if="ListDevices_show" :show_devices="ListDevices_show"></ListDevices>
    <GetReport @close="get_report_dialog=false;" v-if="get_report_dialog" :show_report="get_report_dialog"
               :manage_data="manage_data" :users_l2="users.l2" :users_l1="users.l1"
    ></GetReport>


  </div>
</template>

<script>
import axios from "axios";

import TasksList from "@/components/admin/tasks/list.vue";
import CreateTask from "@/components/admin/tasks/create.vue";
import TasksNav from "@/components/admin/tasks/nav.vue";
import TaskManage from "@/components/admin/tasks/manage.vue";
import ListDevices from "@/components/admin/devices/list.vue";
import GetReport from "@/components/admin/tasks/report.vue";
export default {
  name: "HomeTasks",
  components:{TasksNav, TasksList, CreateTask, TaskManage, ListDevices, GetReport},
  data:()=>({
    key: localStorage.getItem('key'),
    receiving_tasks: true,
    is_searched:false,
    is_filtered:false,
    add_task_dialog:false,
    tab:1,
    tasks:[],
    page: 1,

    filter_by:{},

    manage: {
      show: false,
      manage: 'location',
      title: '',
      items: [
        {title: 'مکان ها', model:'locations'},
        {title: 'تگ ها', model:'tags'},
        {title: 'دسته‌بندی', model:'categories'}
      ],
    },


    manage_data:[],
    users:{l1:[],l2:[],},
    devices:[],
    loading_create_data:false,

    ListDevices_show:false,

    get_report_dialog:false,

    tasks_count:{today_task_count:'-',yesterday_task_count:'-'}
  }),
  created(){
    this.get_tasks_count();
    this.get_tasks()
  },
  methods: {
    filter_name_handler(filter_key){
      switch (filter_key){
        case "user_1":
        {
          return 'کاربر سطح یک'
          break
        }
        case "user_2":
        {
          return 'کاربر سطح دو'
          break
        }
        case "location":
        {
          return 'مکان'
          break
        }
        case "tag":
        {
          return 'تگ'
          break
        }
      }
    },
    filter(filter_by){
      this.page=1;
      this.filter_by = filter_by;
      this.get_filter();
    },
    get_filter(){
      this.tasks = []
      this.receiving_tasks = true;
      axios
          .get(`${this.BACKEND_LINK}/api/tasks/filter/?filter_by=${this.filter_by.key}&value=${this.filter_by.value}&page=${this.page}`,{
            headers: {'Authorization': `Token ${this.key}`}
          })
          .then((response)=>{
            this.tasks = response.data;
            if(this.page===1){
              this.$snotify.success(`${response.data.count} عدد کار پیدا شد`, 'فیلتر')
            }
            this.receiving_tasks = false;
            this.is_filtered = true;
          })
          .catch((errors)=>{
            this.$snotify.error(`مشکلی پیش آمد کد : ${errors.response.status}`, 'فیلتر')
          })
          .finally(()=>{
            this.receiving_tasks = false;
          })

    },
    manage_view(manage){
      this.manage.manage = manage.model;
      this.manage.title = manage.title;
      this.manage.show = true;
    },
    force_update_create_data(){
      this.loading_create_data=true;
      this.manage_data = [];
      this.users.l2 = [];
      this.devices = [];
      this.get_manage_data();
      this.get_users(2);
      this.get_devices();
    },
    get_task_manages_data(){
          if (this.get_report_dialog){this.get_users(1)}
          if(this.manage_data.length===0){
            this.get_manage_data()
          }
          if(this.users.l2.length===0){
            this.get_users(2)
          }
          if(this.devices.length===0){
            this.get_devices()
          }
    },
    get_users(degree=2){
      axios.get(`${this.BACKEND_LINK}/api/account/users-filter-degree/?degree=${degree}`,{
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        this.users[`l${degree}`] = response.data;
        if(this.manage_data && this.users_l2 && this.devices){this.loading_create_data=false;}
      }).catch(()=>{
        this.$snotify.error(`خطا در دریافت کاربران!`, 'خطا')
      })
    },
    get_manage_data(){
      axios.get(`${this.BACKEND_LINK}/api/tasks/manage/?model=*`, {
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        this.manage_data = response.data;
        if(this.manage_data && this.users_l2 && this.devices){this.loading_create_data=false;}
      })
    },
    get_devices(){
      axios
          .get(`${this.BACKEND_LINK}/api/devices/all/`,{
            headers: {'Authorization': `Token ${this.key}`}
          })
          .then((response)=>{
            this.devices = response.data;
            if(this.manage_data && this.users_l2 && this.devices){this.loading_create_data=false;}
          })
    },

    change_page(page){
      this.page = page;
      if(!this.is_filtered){
        this.get_tasks()
      }else{
        this.get_filter();
      }
    },
    change_tab(tab){
      this.tab = tab;
      this.get_tasks()
      },

    search_by_title(search_field) {
      if(search_field && search_field.length >= 3){
        this.receiving_tasks = true;
        this.tasks = {results:[]};
        axios
            .get(`${this.BACKEND_LINK}/api/tasks/search/?search=${search_field}`,{
              headers: {'Authorization': `Token ${this.key}`}
            })
            .then((response)=>{
              this.tasks.results = response.data;
              this.$snotify.success(`${response.data.length} عدد کار پیدا شد`, 'فیلتر')
              this.receiving_tasks = false;
              this.is_searched = true;
            })
            .catch((errors)=>{
              this.$snotify.error(`مشکلی پیش آمد کد : ${errors.response.status}`, 'فیلتر')
              this.receiving_tasks =false;

            })
      }
    },
    get_tasks_count(){
      axios
          .get(`${this.BACKEND_LINK}/api/tasks/count-today-and-yesterday/`, {
            headers: {'Authorization': `Token ${this.key}`}
          })
          .then((response)=>{
            this.tasks_count = response.data;
          })
          .catch(()=>{
            this.$snotify.error('مشکلی در دریافت تعداد کارها وجود دارد!')
          })
    },
    get_tasks(){
      this.receiving_tasks = true;
      this.tasks = [];
      axios
          .get(`${this.BACKEND_LINK}/api/tasks/?page=${this.page}&status=${this.tab?this.tab[4]:'1'}`, {
            headers: {'Authorization': `Token ${this.key}`}
          }).then((response)=>{
            this.tasks = response.data;
            this.receiving_tasks = false;
          }).finally(()=>{
            this.receiving_tasks = false;
          })
    },

  }
}
</script>
